// Navbar mobile device - toggle menu
// -----------------------------------
const toggleMobileMenu = document.querySelector('.navigation-md__head__toggle');
const mobileMenu = document.querySelector('.navigation-md');

toggleMobileMenu.addEventListener('click', (() => {
    mobileMenu.classList.toggle('is--active');
}), false);


// Navbar main
// -----------------------------------
const navHead = document.querySelector('.navigation-md__head');
const navHeadCategory = document.querySelector('.navigation-md__head__category__inner');
const navMain = document.querySelector('.navigation-md__main');
const navSubDepth1 = document.querySelector('.navigation-md__sub-depth-1');
// const navSubDepth2 = document.querySelector('.navigation-md__sub-depth-2');

const menuItemsMain = document.querySelectorAll('[data-menu-level="main"]');
const menuItemsSubDepth1 = document.querySelectorAll('[data-menu-level="sub-depth-1"]');

Array.from(menuItemsMain).forEach((elem) => {
    elem.addEventListener('click', (() => {
        const navSubDepth1Active = document.querySelector('.navigation-md__sub-depth-1.is--active');
        const navSubDepth1CategoryActive = document.querySelector('.navigation-md__sub-depth-1__items__category.is--active');
        // const navSubDepth2Active = document.querySelector('.navigation-md__sub-depth-2.is--active');
        // const navSubDepth2CategoryActive = document.querySelector('.navigation-md__sub-depth-2__items__category.is--active');

        // if (navSubDepth2Active && navSubDepth2CategoryActive) {
        //     navSubDepth2Active.classList.remove('is--active');
        //     navSubDepth2CategoryActive.classList.remove('is--active');
        // }

        if (navSubDepth1Active && navSubDepth1CategoryActive) {
            navSubDepth1Active.classList.remove('is--active');
            navSubDepth1CategoryActive.classList.remove('is--active');
        }

        const navTarget = elem.getAttribute('data-target');
        const elemLink = elem.querySelector('.navigation-md__main__item__link');

        navHead.classList.add('not--main');
        navMain.classList.add('set--back');
        navSubDepth1.classList.add('is--active');

        navHeadCategory.innerHTML = elemLink.innerHTML;

        document.querySelector('[data-category="' + navTarget + '"]').classList.add('is--active');

    }), false);
});

Array.from(menuItemsSubDepth1).forEach((elem) => {
    elem.addEventListener('click', (() => {
        const navTarget = elem.getAttribute('data-target');

        navSubDepth1.classList.add('set--back');
        // navSubDepth2.classList.add('is--active');

        document.querySelector('[data-category="' + navTarget + '"]').classList.add('is--active');

    }), false);
});

// Navbar backbutton
// -----------------------------------
const navSubBack = document.querySelector('.navigation-md__head__back');

navSubBack.addEventListener('click', (() => {
    // if (navSubDepth2.classList.contains('is--active')) {
    //
    //     navSubDepth2.classList.remove('is--active');
    //     navSubDepth1.classList.remove('set--back');
    //
    // } else
    if (navSubDepth1.classList.contains('is--active')) {

        navSubDepth1.classList.remove('is--active');
        navHead.classList.remove('not--main');
        navMain.classList.remove('set--back');

        document.querySelector('.navigation-md__sub-depth-1__items__category.is--active').classList.remove('is--active');

    }
}), false);

// Navbar dropdown
// -----------------------------------
const navDropdownToggle = document.querySelectorAll('[data-nav-dropdown-toggle]');

Array.from(navDropdownToggle).forEach((elem) => {
    elem.addEventListener('click', (() => {

        const dropdownMenu = elem.closest('[data-nav-dropdown-menu]');
        const dropdownList = dropdownMenu.querySelector('[data-nav-dropdown-list]');
        const dropdownHeight = dropdownList.getBoundingClientRect().height;
        const dropdonwListHolder = dropdownMenu.querySelector('[data-nav-dropdown-list-holder]');

        if (elem.classList.contains('is--active')) {
            elem.classList.remove('is--active');
            dropdonwListHolder.style.height = '0px';
        } else {
            elem.classList.add('is--active');
            dropdonwListHolder.style.height = dropdownHeight + 'px';
        }

    }), false);
});

// Navbar search field toggle
// -----------------------------------
const navSearchToggle = document.querySelector('[data-nav-search-toggle]');
const navMenu = document.querySelector('.navigation-md__menu');
const navSearchInput = document.querySelector('.navigation-md__menu__search');

navSearchToggle.addEventListener('click', (() => {

    if (document.querySelector('.navigation-md__menu.search--open')) {
        navMenu.classList.remove('search--open');
    } else {
        navMenu.classList.add('search--open');
        navSearchInput.querySelector('input').focus();
    }

}), false);



// WEBPACK FOOTER //
// ./javascript/navigation-mobile-device.js